<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  name: string
  size?: string
  filled?: boolean
  class?: string
  ariaLabel?: string
  ariaHidden?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  filled: false,
  ariaHidden: undefined,
})

const iconClass = computed(() => {
  const classes = ['material-symbols-outlined']
  if (props.filled) {
    classes.push('filled')
  }
  if (props.class) {
    classes.push(props.class)
  }
  return classes
})
</script>

<template>
  <span
    class="m-icon"
    :class="iconClass"
    :style="{ fontSize: size }"
    :aria-label="ariaLabel"
    :aria-hidden="ariaHidden !== undefined ? ariaHidden : ariaLabel ? false : true"
    :data-icon="name"
  >
  </span>
</template>

<style>
.m-icon {
  font-family: 'Material Symbols Outlined';
  visibility: hidden;
}

.m-icon:before {
  content: attr(data-icon);
}

html.ms-font-hazir .m-icon {
  visibility: visible;
}

.filled {
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24;
}
</style>
